import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Bar, Line } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';

class RepayDashboard extends Component {
    state = { 
        sortedPaymentList: [],
        payList:[],
        customPeriod: 30
    }
    componentDidMount() {
        this.sortByDate()
    }
    sortByDate = () => {
        const { PAYMENTS } = this.props;
        let list = Object.keys(PAYMENTS)
        list.sort((a, b) => {
            a = new Date(PAYMENTS[a].recordPayment); // or timePayment ??
            b = new Date(PAYMENTS[b].recordPayment);
            if (a > b){
                return 1;
            }
            if (a < b){
                return -1;
            }
            return 0;
        });
        
        this.setState({
            sortedPaymentList:list
        })
    }
    sum = (array, prop) => {
        return array.reduce((acc, obj) => {
            let date = new Date(obj[prop]).toLocaleDateString("fr-FR")
            // var key = Months[date.getMonth()] + " " + date.getFullYear();
            if(!acc[date]){
                acc[date] = 0;
            }
            acc[date] += obj.money;
            return acc;
        }, {});
    }
    count = (array, prop) => {
        return array.reduce((acc, obj) => {
            let date = new Date(obj[prop]).toLocaleDateString("fr-FR")
            // var key = Months[date.getMonth()] + " " + date.getFullYear();
            if(!acc[date]){
                acc[date] = 0;
            }
            acc[date] ++;
            return acc;
        }, {});
    }
    
    calcData = () => {
        const { sortedPaymentList, customPeriod } = this.state;
        const { PAYMENTS } = this.props;
        let oneDayTS = 24 * 60 * 60 * 1000
        let payList = []
        let dateLimit =  Date.now() - (customPeriod * oneDayTS)
        let totalSum = 0

        let dataSumObject = {}
        let bgSum = []
        let dataCumulObject = {}
        let bgCumul = []
        let dataCountObject = {}
        let bgCount = []
        let dataAverageObject = {}
        let bgAverage = []

        if(isEmpty(sortedPaymentList) && !isEmpty(PAYMENTS) ){
            this.sortByDate()
        }


        sortedPaymentList.forEach(ID => {
            let pay = PAYMENTS[ID]
            let dateP =  new Date(pay.recordPayment).getTime()

            if( dateP >= dateLimit  && pay.methodPayment !== 'gift'){
                payList.push(pay)
            }
        })
        
        let payObject = this.sum(payList, "recordPayment")
        let payCount = this.count(payList, "recordPayment")

        for (let i = 0; i < customPeriod; i++) {
            let key = new Date( dateLimit + (oneDayTS * i) ).toLocaleDateString("fr-FR")

            totalSum += payObject[key] || 0

            dataSumObject[key] = payObject[key] || 0;
            bgSum.push( 'rgba(255, 203, 96, 0.8)' )

            dataCumulObject[key] = totalSum;
            bgCumul.push( 'rgba(0, 135, 0, 0.6)' )

            dataCountObject[key] = payCount[key] || 0;
            bgCount.push( 'rgba(111, 198, 215, 0.7)' )

            dataAverageObject[key] = payObject[key] ? Math.round( payObject[key]/payCount[key] ) : 0
            bgAverage.push( 'rgba(196, 105, 143, 0.6)' )
        }

        console.log('====================================');
        console.log({payObject, dataSumObject});
        console.log('====================================');
        return {
            list: payList, 
            totalSum,
            totalCount: payList.length,
            dataSumObject, 
            bgSum,
            dataCumulObject, 
            bgCumul,
            dataCountObject, 
            bgCount,
            dataAverageObject, 
            bgAverage,
        }
        
    }
   
    render() {
        const { PAYMENTS } = this.props;
        let payList = this.calcData()
        console.log('====================================');
        console.log("REPAY DASHBOARD STATE",this.state);
        console.log('====================================');

        const data = {
            labels: Object.keys(payList.dataSumObject),
            datasets:[
                {
                    label:"Montant Total des paiements",
                    data: Object.values(payList.dataSumObject),
                    backgroundColor:payList.bgSum,
                },
                {
                    label:`Paiement Moyen`,
                    data: Object.values(payList.dataAverageObject),
                    backgroundColor:payList.bgAverage,
                },
                
            ]
        }
        const data2 = {
            labels: Object.keys(payList.dataCumulObject),
            datasets:[
                {
                    label:"Cumul des Paiements",
                    data: Object.values(payList.dataCumulObject),
                    backgroundColor:payList.bgCumul,
                },
                // {
                //     label:'Pourcentage des retards par type d\'abonnement',
                //     data: Object.values(this.state.percentage2),
                //     backgroundColor:this.state.bgSum2,
                // },
            ]
        }
        const data3 = {
            labels: Object.keys(payList.dataCountObject),
            datasets:[
                {
                    label:"Nombre de Paiements",
                    data: Object.values(payList.dataCountObject),
                    backgroundColor:payList.bgCount,
                },
                // {
                //     label:'Pourcentage des retards par type d\'abonnement',
                //     data: Object.values(this.state.percentage2),
                //     backgroundColor:this.state.bgSum2,
                // },
            ]
        }

        return (
            <div>
                <h3>Statistiques de paiements</h3>
                <Grid>
                    <Grid item xs={12} md={2} className="m-t-20">
                        <h4>Periode</h4>
                        <label className="radio radio-inline m-r-20 m-b-10 m-l-10">
                        <input type="radio" name="aboRadio" 
                            checked= { (this.state.customPeriod === 10 ? true : false)}
                            onChange={() => this.setState({ customPeriod: 10})} />
                            <i className="input-helper"></i>
                            <span>10 derniers Jours</span>
                        </label>
                        
                        <label className="radio radio-inline m-r-20 m-b-10 ">
                            <input type="radio" name="customPeriod" 
                                checked= { (this.state.customPeriod === 20 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 20})} />
                            <i className="input-helper"></i>
                            <span>20 derniers Jours</span>
                        </label>
                        <label className="radio radio-inline m-r-20 m-b-10">
                            <input type="radio" name="customPeriod" 
                                checked= { (this.state.customPeriod === 30 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 30})} />
                            <i className="input-helper"></i>
                            <span>30 derniers Jours</span>
                        </label>
                        <label className="radio radio-inline m-r-20 m-b-10">
                            <input type="radio" name="customPeriod" 
                                checked= { (this.state.customPeriod === 60 ? true : false)}
                                onChange={() => this.setState({ customPeriod: 60})} />
                            <i className="input-helper"></i>
                            <span>60 derniers Jours</span>
                        </label>
                    </Grid>
                    <Grid item xs={12} md={10} >
                        <h4 className="text-right"><i>Montant Total : {payList.totalSum.toLocaleString('fr-FR')}FCFA <small>pour {payList.totalCount} paiements</small></i></h4>
                        {!isEmpty(this.props.PAYMENTS) &&
                        <div>

                            <div className="chart">
                                <Bar
                                    data={data}
                                    options={{
                                        title:{
                                            display: true,
                                            text:`Montant des paiements des ${this.state.customPeriod} derniers jours`,
                                            fontSize:19
                                        },
                                    }}
                                />
                            </div>
                            <hr/>
                        
                            <div className="chart">
                                <Line
                                    data={data2}
                                    options={{
                                        title:{
                                            display: true,
                                            text:`Cumul des paiements des ${this.state.customPeriod} derniers jours`,
                                            fontSize:19
                                        },
                                    }}
                                />
                            </div>
                            <div className="chart">
                                <Bar
                                    data={data3}
                                    options={{
                                        title:{
                                            display: true,
                                            text:`Nombre de paiements des ${this.state.customPeriod} derniers jours`,
                                            fontSize:19
                                        },
                                    }}
                                />
                            </div>
                            
                        </div>

                        }
                        <hr/>
                    </Grid>
                </Grid>
            
            </div>
        );
    }
}
function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
      PAYMENT_STATE: state.inventory.requestState.payments,
      PAYMENTS: state.payments,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
    //   getPayments,
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps )(RepayDashboard);